import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, vShow as _vShow, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, withCtx as _withCtx, createVNode as _createVNode, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, createTextVNode as _createTextVNode, createBlock as _createBlock } from "vue"
import _imports_0 from '@/assets/icons/icon-arrow-back.svg'


const _hoisted_1 = { class: "page-wr" }
const _hoisted_2 = { class: "dashboard-header" }
const _hoisted_3 = { class: "title-main" }
const _hoisted_4 = { class: "subtitle-main subtitle-main--documents" }
const _hoisted_5 = { class: "filters" }
const _hoisted_6 = ["onClick"]
const _hoisted_7 = {
  key: 0,
  class: "spinner"
}
const _hoisted_8 = {
  key: 1,
  class: "empty-block--wrapper"
}
const _hoisted_9 = ["src"]
const _hoisted_10 = {
  key: 2,
  class: "table-wrapper"
}
const _hoisted_11 = { class: "table-controls" }
const _hoisted_12 = { class: "lots-actions" }
const _hoisted_13 = {
  key: 0,
  class: "items-count"
}
const _hoisted_14 = {
  key: 1,
  class: "items-count"
}
const _hoisted_15 = { class: "extra-columns-list" }
const _hoisted_16 = { class: "dropdown-button tabs-list" }
const _hoisted_17 = ["src"]
const _hoisted_18 = { class: "lots-table-scroll scroll-wrapper" }
const _hoisted_19 = { class: "table-default" }
const _hoisted_20 = { class: "checkbox" }
const _hoisted_21 = { key: 0 }
const _hoisted_22 = { key: 1 }
const _hoisted_23 = { key: 2 }
const _hoisted_24 = { key: 3 }
const _hoisted_25 = { key: 4 }
const _hoisted_26 = ["onClick"]
const _hoisted_27 = ["onClick"]
const _hoisted_28 = { class: "text-bordered" }
const _hoisted_29 = { key: 0 }
const _hoisted_30 = { key: 1 }
const _hoisted_31 = { key: 2 }
const _hoisted_32 = { key: 3 }
const _hoisted_33 = { key: 4 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("span", {
        class: "wrapper-back",
        onClick: _cache[0] || (_cache[0] = ($event: any) => ($setup.router.push({ name: 'Stages' })))
      }, [...(_cache[15] || (_cache[15] = [
        _createElementVNode("div", { class: "back" }, [
          _createElementVNode("img", { src: _imports_0 }),
          _createElementVNode("span", { class: "back-title" }, "Back")
        ], -1)
      ]))])
    ]),
    _createElementVNode("h2", _hoisted_3, "Stage " + _toDisplayString($setup.stage ? $setup.stage.title : ""), 1),
    _createElementVNode("div", _hoisted_4, _toDisplayString($setup.plural($setup.lots.length, "lot")), 1),
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("div", null, [
        _createVNode($setup["DropDown"], { class: "dropdown dropdown--status" }, {
          control: _withCtx(() => [
            _withDirectives(_createElementVNode("button", { class: "dropdown-button" }, "Lot status is " + _toDisplayString($setup.activeFilter.label === $setup.LotStatus.EOI ? $setup.LotStatus.PRE_CONTRACT : $setup.activeFilter.label), 513), [
              [_vShow, $setup.viewType === 'list']
            ])
          ]),
          dropdown: _withCtx(() => [
            _createElementVNode("ul", null, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.filters, (item) => {
                return (_openBlock(), _createElementBlock("li", {
                  onClick: ($event: any) => ($setup.changeFilter(item)),
                  class: _normalizeClass({ 'dropdown__item-active': $setup.activeFilter.label === item.label })
                }, _toDisplayString(item.label === $setup.LotStatus.EOI ? $setup.LotStatus.PRE_CONTRACT : item.label), 11, _hoisted_6))
              }), 256))
            ])
          ]),
          _: 1
        })
      ]),
      _createElementVNode("button", {
        class: _normalizeClass(["icon-btn", $setup.viewType === 'list' ? 'map-view' : 'list-view']),
        onClick: $setup.changeView
      }, _toDisplayString($setup.viewType === "list" ? "map" : "list"), 3)
    ]),
    ($setup.isLoading)
      ? (_openBlock(), _createElementBlock("div", _hoisted_7))
      : ($setup.lots.length === 0)
        ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
            _createElementVNode("img", {
              class: "empty-block--icon",
              src: require('@/assets/icons/lot-slim.svg')
            }, null, 8, _hoisted_9),
            _cache[16] || (_cache[16] = _createElementVNode("p", null, "You don't have lots", -1))
          ]))
        : ($setup.viewType === 'list')
          ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
              _createElementVNode("div", _hoisted_11, [
                _createElementVNode("div", _hoisted_12, [
                  ($setup.selectedLotsList.length > 0)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_13, _toDisplayString($setup.plural($setup.selectedLotsList.length, "lot")) + " selected", 1))
                    : (_openBlock(), _createElementBlock("div", _hoisted_14, _toDisplayString($setup.plural($setup.lots.length, "lot")), 1)),
                  _createElementVNode("button", {
                    class: _normalizeClass(["table-controls-button release", { show: $setup.showRelease }]),
                    onClick: _cache[1] || (_cache[1] = ($event: any) => ($setup.clickReleaseLot()))
                  }, "Release lots", 2),
                  _createElementVNode("button", {
                    class: _normalizeClass(["table-controls-button create", { show: $setup.showCreateOption }]),
                    onClick: _cache[2] || (_cache[2] = ($event: any) => ($setup.clickAction('option')))
                  }, "Create option", 2),
                  _createElementVNode("button", {
                    class: _normalizeClass(["table-controls-button set-date", { show: $setup.selectedLotsList.length > 0 }]),
                    onClick: _cache[3] || (_cache[3] = ($event: any) => ($setup.clickAction('setDate')))
                  }, "Set registration date", 2)
                ]),
                _createElementVNode("div", _hoisted_15, [
                  _createVNode($setup["DropDown"], { placement: 'width-by-content right' }, {
                    control: _withCtx(() => [
                      _createElementVNode("button", _hoisted_16, [
                        _createElementVNode("img", {
                          src: require('@/assets/icons/icon-table.svg')
                        }, null, 8, _hoisted_17)
                      ])
                    ]),
                    dropdown: _withCtx(() => [
                      _createElementVNode("ul", null, [
                        _createElementVNode("li", {
                          onClick: _cache[4] || (_cache[4] = _withModifiers(($event: any) => ($setup.showAllColumns(false)), ["stop"]))
                        }, "Unpin all columns"),
                        _createElementVNode("li", {
                          onClick: _cache[5] || (_cache[5] = _withModifiers(($event: any) => ($setup.showAllColumns(true)), ["stop"]))
                        }, "Show all columns"),
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.extraColumns, (item, index) => {
                          return (_openBlock(), _createElementBlock("li", { key: index }, [
                            _createVNode($setup["CheckboxInput"], {
                              label: item.value,
                              onClick: _cache[6] || (_cache[6] = _withModifiers(() => {}, ["stop"])),
                              modelValue: item.isSelected,
                              "onUpdate:modelValue": ($event: any) => ((item.isSelected = $event), $setup.saveSelectedLotExtraColumns())
                            }, null, 8, ["label", "modelValue", "onUpdate:modelValue"])
                          ]))
                        }), 128))
                      ])
                    ]),
                    _: 1
                  })
                ])
              ]),
              _createElementVNode("div", _hoisted_18, [
                _createElementVNode("table", _hoisted_19, [
                  _createElementVNode("thead", null, [
                    _createElementVNode("tr", null, [
                      _createElementVNode("th", _hoisted_20, [
                        _createVNode($setup["CheckboxInput"], {
                          checkedPartial: $setup.selectedLotsList.length > 0 && $setup.selectedLotsList.length !== $setup.lotList.length,
                          modelValue: $setup.isSelectAll,
                          "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ($setup.selectAll($event)))
                        }, null, 8, ["checkedPartial", "modelValue"])
                      ]),
                      _cache[17] || (_cache[17] = _createElementVNode("th", null, "Lot No.", -1)),
                      _cache[18] || (_cache[18] = _createElementVNode("th", null, "Street Name", -1)),
                      _cache[19] || (_cache[19] = _createElementVNode("th", null, "Price", -1)),
                      _cache[20] || (_cache[20] = _createElementVNode("th", null, [
                        _createTextVNode("Size, m"),
                        _createElementVNode("sup", null, "2")
                      ], -1)),
                      ($setup.extraColumns.purchaser.isSelected)
                        ? (_openBlock(), _createElementBlock("th", _hoisted_21, "Assigned to"))
                        : _createCommentVNode("", true),
                      ($setup.extraColumns.exchanged.isSelected)
                        ? (_openBlock(), _createElementBlock("th", _hoisted_22, "Exchanged"))
                        : _createCommentVNode("", true),
                      ($setup.extraColumns.financeDue.isSelected)
                        ? (_openBlock(), _createElementBlock("th", _hoisted_23, "Finance due"))
                        : _createCommentVNode("", true),
                      ($setup.extraColumns.settlement.isSelected)
                        ? (_openBlock(), _createElementBlock("th", _hoisted_24, "Settlement"))
                        : _createCommentVNode("", true),
                      _cache[21] || (_cache[21] = _createElementVNode("th", null, "Status", -1)),
                      ($setup.estateHasCollaborators)
                        ? (_openBlock(), _createElementBlock("th", _hoisted_25, "Business"))
                        : _createCommentVNode("", true)
                    ])
                  ]),
                  _createElementVNode("tbody", null, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.lots, (lot, index) => {
                      return (_openBlock(), _createElementBlock("tr", {
                        onClick: ($event: any) => ($setup.toLot(lot._id))
                      }, [
                        _createElementVNode("td", {
                          class: "checkbox",
                          onClick: _withModifiers(($event: any) => ($setup.selectLot(!$setup.lotList[index].selected, index)), ["stop"])
                        }, [
                          _createElementVNode("div", {
                            class: _normalizeClass(["bordered", $setup.getDisplayStatusClass(lot.status)])
                          }, null, 2),
                          _createVNode($setup["CheckboxInput"], {
                            onClick: _cache[8] || (_cache[8] = _withModifiers(() => {}, ["stop"])),
                            modelValue: $setup.lotList[index].selected,
                            "onUpdate:modelValue": ($event: any) => ($setup.selectLot($event, index))
                          }, null, 8, ["modelValue", "onUpdate:modelValue"])
                        ], 8, _hoisted_27),
                        _createElementVNode("td", {
                          class: "bold",
                          onClick: _cache[9] || (_cache[9] = () => {})
                        }, [
                          _createElementVNode("span", _hoisted_28, "Lot " + _toDisplayString(lot.title), 1)
                        ]),
                        _createElementVNode("td", null, _toDisplayString(lot.streetName || "--"), 1),
                        _createElementVNode("td", null, _toDisplayString($setup.formatPrice(lot.price)), 1),
                        _createElementVNode("td", null, _toDisplayString($setup.formatPrice(lot.size, false)), 1),
                        ($setup.extraColumns.purchaser.isSelected)
                          ? (_openBlock(), _createElementBlock("td", _hoisted_29, _toDisplayString($setup.getPurchaser(lot)), 1))
                          : _createCommentVNode("", true),
                        ($setup.extraColumns.exchanged.isSelected)
                          ? (_openBlock(), _createElementBlock("td", _hoisted_30, _toDisplayString(lot.exchangedDate ? $setup.formatDate(lot.exchangedDate, "D MMM YYYY") : "--"), 1))
                          : _createCommentVNode("", true),
                        ($setup.extraColumns.financeDue.isSelected)
                          ? (_openBlock(), _createElementBlock("td", _hoisted_31, _toDisplayString(lot.financeDueDate ? $setup.formatDate(lot.financeDueDate, "D MMM YYYY") : "--"), 1))
                          : _createCommentVNode("", true),
                        ($setup.extraColumns.settlement.isSelected)
                          ? (_openBlock(), _createElementBlock("td", _hoisted_32, _toDisplayString(lot.settlementDate ? $setup.formatDate(lot.settlementDate, "D MMM YYYY") : "--"), 1))
                          : _createCommentVNode("", true),
                        _createElementVNode("td", null, [
                          _createElementVNode("div", {
                            class: _normalizeClass(["badge", $setup.getDisplayStatusClass(lot.status)])
                          }, _toDisplayString(lot.status === $setup.LotStatus.EOI ? $setup.LotStatus.PRE_CONTRACT : lot.status), 3),
                          (lot.status === $setup.LotStatus.OFFLINE)
                            ? (_openBlock(), _createElementBlock("div", {
                                key: 0,
                                class: _normalizeClass(["badge bordered-badge", `bordered-badge-${$setup.getLotStatusClass(lot.offlineSale.salePhase)}`])
                              }, _toDisplayString(lot.offlineSale.salePhase === $setup.LotStatus.EOI ? $setup.LotStatus.HOLD : lot.offlineSale.salePhase), 3))
                            : _createCommentVNode("", true)
                        ]),
                        ($setup.estateHasCollaborators)
                          ? (_openBlock(), _createElementBlock("td", _hoisted_33, _toDisplayString($setup.getBusinessNameFromLot(lot, $setup.businesses)), 1))
                          : _createCommentVNode("", true)
                      ], 8, _hoisted_26))
                    }), 256))
                  ])
                ])
              ])
            ]))
          : (_openBlock(), _createBlock($setup["StageMap"], {
              key: 3,
              class: "map"
            })),
    _createVNode($setup["ReleaseLotsModal"], {
      onClose: _cache[10] || (_cache[10] = ($event: any) => ($setup.closeReleaseModal($event))),
      isOpen: $setup.showReleaseModal,
      showClose: false,
      listForUpdate: $setup.selectedForReleaseList,
      stageId: $setup.router.currentRoute.value.params.stageId
    }, null, 8, ["isOpen", "listForUpdate", "stageId"]),
    _createVNode($setup["CreateOptionModal"], {
      onClose: _cache[11] || (_cache[11] = ($event: any) => ($setup.closeCreateOptionModal($event))),
      isOpen: $setup.showCreateOptionModal,
      showClose: false,
      listForUpdate: $setup.selectedForOptionList,
      registrationDate: $setup.registrationDate
    }, null, 8, ["isOpen", "listForUpdate", "registrationDate"]),
    _createVNode($setup["SetRegistrationDateModal"], {
      onClose: _cache[12] || (_cache[12] = ($event: any) => ($setup.closeRegDateModal($event))),
      isOpen: $setup.showRegDateModal,
      showClose: false,
      listForUpdate: $setup.lotList,
      onUpdate: $setup.onUpdateRegistrationDate
    }, null, 8, ["isOpen", "listForUpdate"]),
    _createVNode($setup["TransitionModal"], {
      onProceed: _cache[13] || (_cache[13] = ($event: any) => ($setup.proceed())),
      onClose: _cache[14] || (_cache[14] = ($event: any) => ($setup.showTransitionModal = !$setup.showTransitionModal)),
      isOpen: $setup.showTransitionModal,
      showClose: false,
      attentionType: $setup.attentionType
    }, null, 8, ["isOpen", "attentionType"])
  ]))
}